exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html,\nbody,\n#root {\n  height: 100%;\n  /* background: #777; */\n}\na,\na:visited,\na:hover {\n  color: black;\n}", ""]);

// exports
